import { render } from "./user_register.vue?vue&type=template&id=71694a6a"
import script from "./user_register.vue?vue&type=script&lang=js"
export * from "./user_register.vue?vue&type=script&lang=js"

import "./user_register.vue?vue&type=style&index=0&id=71694a6a&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__